import React from "react";
import ProcessFlow from "../components/ProcessFlow";

const HowItWorks = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 px-4 bg-dark">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-light mb-6">
            How We Work Together
          </h1>
          <p className="text-xl text-light/80 max-w-3xl mx-auto">
            A streamlined consulting journey focused on transparency, tangible
            outcomes, and meaningful collaboration. Here's what to expect when
            we partner.
          </p>
        </div>

        {/* Process Flow Component */}
        <ProcessFlow />

        {/* Partnership Benefits */}
        <div className="mt-16 text-center p-8 border border-light/10 rounded-xl bg-dark/50 backdrop-blur-sm">
          <h2 className="text-2xl md:text-3xl font-bold text-light mb-4">
            Ready to Begin Your Journey?
          </h2>
          <p className="text-light/80 text-lg max-w-3xl mx-auto mb-6">
            Start with a free consultation call to explore how my consulting
            expertise can help navigate your organization's specific challenges
            and opportunities.
          </p>
          <button
            className="px-8 py-3 bg-accent text-dark rounded-md font-medium hover:bg-accent/90 transition-colors"
            onClick={() => (window.location.href = "/contact")}
          >
            Schedule Your Free Call
          </button>
        </div>

        {/* Client Testimonial Teaser */}
        <div className="mt-16 text-center">
          <p className="text-light/70">
            Join dozens of satisfied clients who have accelerated their
            strategic initiatives through our structured consulting approach.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
